module.exports = __webpack_public_path__ + "media/styles/images/svg/pencil-teal-54ee199e90557351fc137ce0c20f8f71.svg";